// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--ORd11"};